/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { IAppLearningResp } from 'generated-types';

interface IAppInsightsData {
    appInsights: IAppLearningResp;
    lastUpdatedTimestamp: number;
    // Once app insights have been loaded once, even if the data is empty we can show the empty datagrid instead of
    // displaying the initial "No Insights Found" image.
    initialLoaded: boolean;
}

/**
 * Interface for app insights state
 */
export interface IAppInsightsState {
    appInsightsByVs: Record<string, IAppInsightsData>;
    loading: boolean;
    error: string | null;
}

/**
 * Initial state for app insights store
 */
export const initialState: IAppInsightsState = {
    appInsightsByVs: {},
    loading: false,
    error: null,
};
